import useAuth from '@hooks/auth.hook';
import LogoImage from '@features/main/components/Logo/Logo.svg';
import useLoginPageStyles from './LoginPage.styles';

const LoginPage: React.FC = () => {
	const classes = useLoginPageStyles();
	const { loginWithGoogle } = useAuth();

	return (
		<div className={classes.root} id="login-page">
			<div className={classes.card}>
				<img
					alt="Logo Coordinadora"
					className={classes.logo}
					src={LogoImage}
					style={{ filter: 'brightness(0) saturate(100%)' }}
				/>
				<h1 className={classes.title}>Bienvenido</h1>
				<p className={classes.subtitle}>Ingresa con tu cuenta corporativa de Google.</p>
				<button
					className={classes.button}
					id="login-google-button"
					onClick={() => loginWithGoogle()}
					type="button"
				>
					Iniciar sesión con Google
				</button>
				<p className={classes.corporateHint}>
					Ingresa con tu correo corporativo @coordinadora.com
				</p>
			</div>
		</div>
	);
};

export default LoginPage;
